export default __webpack_public_path__ + "static/media/avatar_arrow_boy8.b698f4c0.mp3";